import React, { Component } from "react";

import ProductosPageListItem from "./productosPageListItem";

class ProductosPageList extends Component {
  state = {};
  render() {
    const { productos, categoria } = this.props;

    if (categoria && categoria.subCategorias && categoria.subCategorias.length > 0) {
      // Group products by subcategory
      const productsBySubCategory = {};
      categoria.subCategorias.forEach((sub) => {
        productsBySubCategory[sub.id] = productos.filter(
          (p) => p.idSubCategoria === sub.id
        );
      });

      return (
        <div id="productosPageList">
          {categoria.subCategorias.map((sub) => {
            const subProducts = productsBySubCategory[sub.id];
            if (subProducts.length === 0) return null;

            return (
              <div
                key={sub.id}
                id={`subcategoria-${sub.nombre.replace(/\s+/g, "-")}`}
                className="subcategoria-section"
                style={{ clear: 'both' }}
              >
                <h2 className="subcategoria-title" style={{ width: '100%', clear: 'both', padding: '20px 0 10px 0' }}>{sub.nombre}</h2>
                <div className="productos-grid">
                  {subProducts.map((producto, index) => (
                    <React.Fragment key={producto.id}>
                      <ProductosPageListItem
                        onCantidadChanged={this.props.onCantidadChanged}
                        productoId={producto.id}
                        imagenUrl={producto.imagenUrl}
                        descripcion={producto.descripcion}
                        cantidad={producto.cantidad}
                        precio={producto.precio}
                        unidad={producto.unidad}
                        intervalo={producto.intervalo}
                        agotado={producto.agotado}
                      />
                      {(index + 1) % 2 === 0 && <div className="productosClear productosClear2"></div>}
                      {(index + 1) % 3 === 0 && <div className="productosClear productosClear3"></div>}
                      {(index + 1) % 5 === 0 && <div className="productosClear productosClear5"></div>}
                    </React.Fragment>
                  ))}
                  <div className="clear"></div>
                </div>
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <div id="productosPageList">
        {productos.map((producto) => (
          <ProductosPageListItem
            key={producto.id}
            onCantidadChanged={this.props.onCantidadChanged}
            productoId={producto.id}
            imagenUrl={producto.imagenUrl}
            descripcion={producto.descripcion}
            cantidad={producto.cantidad}
            precio={producto.precio}
            unidad={producto.unidad}
            intervalo={producto.intervalo}
            agotado={producto.agotado}
          />
        ))}
      </div>
    );
  }
}

export default ProductosPageList;
